export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_94396)">
                <path
                    d="M12.2 5.5H11.4C7.86538 5.5 5 8.36538 5 11.9V26.3C5 26.9627 5.53726 27.5 6.2 27.5H13V6.3C13 5.85817 12.6418 5.5 12.2 5.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M27 21.1C27.3314 21.1 27.6 20.8314 27.6 20.5C27.6 20.1686 27.3314 19.9 27 19.9V21.1ZM24 21.1H27V19.9H24V21.1Z" fill="black" />
                <path
                    d="M24 11.5L24 9.7C24 7.93269 22.5673 6.5 20.8 6.5L13 6.5L13 11.5L24 11.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22 14.5L22 11.5L18 11.5L18 14.5L22 14.5Z" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M24 21L24 19.5L17 19.5L17 21C17 22.933 18.567 24.5 20.5 24.5C22.433 24.5 24 22.933 24 21Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 27.5L26.4 27.5C26.7314 27.5 27 27.2314 27 26.9C27 25.5745 25.9255 24.5 24.6 24.5L13 24.5L13 27.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_7177_94396">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
